var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39911_119355)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_39911_119355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8186 2.08957C14.6304 1.74774 15.5008 2.43423 15.3574 3.30338L13.6643 13.5693C13.501 14.5591 12.4139 15.1271 11.5058 14.6338C10.7458 14.2211 9.61842 13.5858 8.60233 12.9219C8.09495 12.5903 6.54134 11.5272 6.7323 10.7704C6.89558 10.1234 9.50737 7.69215 10.9999 6.24629C11.5861 5.67835 11.3191 5.35024 10.6267 5.87317C8.90918 7.17037 6.15166 9.14263 5.23977 9.69769C4.43522 10.1874 4.01514 10.271 3.51407 10.1874C2.59908 10.0349 1.75076 9.79881 1.05819 9.51173C0.122114 9.12368 0.167709 7.8373 1.05755 7.46268L13.8186 2.08957Z",
    fill: "#00326D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39911_119355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_39911_119355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.798aa0b73f0b97f962af7e5c98c94247.svg";
export { ForwardRef as ReactComponent };